<header class="header pe-5 d-flex flex-row justify-content-between align-items-center position-relative">
  <div
    class="header-logo position-relative d-flex flex-wrap align-items-center justify-content-start px-6 overflow-hidden gap-3 gap-md-0"
  >
    <div class="d-flex flex-no-wrap">
      <i
        class="d-xl-none pointer icon-lg fa-solid fa-fw fa-bars mt-2 me-3"
        (click)="openOffcanvasSidebar(appSectionsSidebar)"
      ></i>
      <img
        class="img-fluid pointer"
        [src]="logo"
        alt="Logo"
        [routerLink]="stazzleLogoUrl"
        [replaceUrl]="true"
      />
    </div>
    <div class="header-dot mx-4 mt-1 d-md-block d-none"></div>
    <div class="header-title mt-1 overflow-hidden">
      <base-page-title></base-page-title>
    </div>
  </div>

  <div class="header-right d-flex justify-content-between align-items-center mt-0">
    <div class="header-user-nav d-flex justify-content-between align-items-center">
      <ng-container *ngIf="isFullscreen">
        <base-button
          baseBackButton
          [size]="buttonSizes.lg"
          [iconSize]="buttonSizes.lg"
          color="dark"
          icon="fa-solid fa-close"
        ></base-button>
      </ng-container>
      <ng-container *ngIf="!isFullscreen && !isErrorPage">
        <base-user-nav
          [userMenu]="userMenu"
          [helpSourceUrl]="helpSourceUrl"
          (openUserMenuSidebar)="openOffcanvasSidebar(userMenuSidebar, true)"
        ></base-user-nav>
      </ng-container>
      <ng-container *ngIf="!isFullscreen && isErrorPage">
        <base-error-page-header-nav></base-error-page-header-nav>
      </ng-container>
    </div>
  </div>
</header>

<ng-template #appSectionsSidebar>
  <div class="offcanvas-body">
    <base-application-sections-sidebar
      [sections]="applicationSections"
      [helpSourceUrl]="helpSourceUrl"
      [areSectionsVisible]="!isErrorPage"
    ></base-application-sections-sidebar>
  </div>
</ng-template>

<ng-template #userMenuSidebar>
  <div class="offcanvas-body">
    <base-base-user-menu-sidebar [userMenu]="userMenu"></base-base-user-menu-sidebar>
  </div>
</ng-template>
